import {mapMutations, mapGetters, mapActions} from "vuex";

export default {
    name: 'basket-product',
    data() {
        return {
            productItem: ''
        }
    },
    created() {

        this.orderStatus()
    },
    props: {
        item: {
            type: Object,
            default: () => {
            }
        },
        product: {
            type: Object,
            default: () => {
            }
        }
    },
    computed: {
        ...mapGetters({
            getStatus: 'order/orderStatus'
        }),
        getCurrentStatus() {

        },
    },
    methods: {
        ...mapActions({
            orderStatus: 'order/ORDER_STATUS'
        })
    }

}
